var path = 'app/components/radniNalog/radniNalogCreate.html';
var html = "<header id=\"header\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><div class=\"content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"hpanel\"><div class=\"panel-heading\"></div><div class=\"panel-body\"><radni-nalog-wizard-form fields=\"vm.fields\" on-submit=\"vm.submit(item)\" item=\"vm.item\"></radni-nalog-wizard-form></div></div></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/radniNalog/radniNalogCreate.html
// module id = 620
// module chunks = 0